import React, { createContext, useContext, useReducer } from 'react';

export const ProfConsultFilterContext = createContext();

export const ProfConsultFilterState = ({ reducer, initialState, children }) => (
  <ProfConsultFilterContext.Provider value={useReducer(reducer, initialState)}>{children}</ProfConsultFilterContext.Provider>
);

export const useStateProfConsultFilterValue = () => useContext(ProfConsultFilterContext);